<div class="d-flex justify-content-between align-items-center">
  <button class="update-button btn btn-primary" (click)="onSubmit()" [disabled]="buttonDisabled()">
    <span class="p-2">{{ "action.update" | translate }}</span>
  </button>
</div>
